import { getContrast } from '../../utils/colorUtility'

export const gray = () => ({
  '050': { color: '#F9FAFB', lightRatio: 1.17, darkRatio: 17.95 },
  100: { color: '#EDEDEE', lightRatio: 1.17, darkRatio: 17.95 },
  200: { color: '#D5D5D7', lightRatio: 1.47, darkRatio: 14.33 },
  300: { color: '#B3B3B8', lightRatio: 2.09, darkRatio: 10.06 },
  400: { color: '#909096', lightRatio: 3.17, darkRatio: 6.62 },
  500: { color: '#6F6F77', lightRatio: 4.98, darkRatio: 4.22 },
  600: { color: '#43434C', lightRatio: 9.79, darkRatio: 2.15 },
  700: { color: '#38383f', lightRatio: 11.63, darkRatio: 1.81 },
  800: { color: '#2D2D33', lightRatio: 13.68, darkRatio: 1.53 },
  900: { color: '#242428', lightRatio: 15.46, darkRatio: 1.36 }
})

export const blue = () => ({
  '050': { color: '#F3FBFF', lightRatio: 1.12, darkRatio: 18.74 },
  100: { color: '#E6F4FE', lightRatio: 1.12, darkRatio: 18.74 },
  200: { color: '#C2E5FE', lightRatio: 1.32, darkRatio: 15.93 },
  300: { color: '#91D0FC', lightRatio: 1.66, darkRatio: 12.63 },
  400: { color: '#2EA5FA', lightRatio: 2.67, darkRatio: 7.88 },
  500: { color: '#0091F9', lightRatio: 3.27, darkRatio: 6.42 },
  600: { color: '#007BD4', lightRatio: 4.39, darkRatio: 4.78 },
  700: { color: '#0067B1', lightRatio: 5.87, darkRatio: 3.57 },
  800: { color: '#00538E', lightRatio: 7.99, darkRatio: 2.63 },
  900: { color: '#004170', lightRatio: 10.55, darkRatio: 1.99 }
})

export const indigo = () => ({
  '050': { color: '#EDE9FF', lightRatio: 1.19, darkRatio: 17.70 },
  100: { color: '#D5CAFF', lightRatio: 1.53, darkRatio: 13.72 },
  200: { color: '#B3A1FF', lightRatio: 2.22, darkRatio: 9.46 },
  300: { color: '#8F75FF', lightRatio: 3.41, darkRatio: 6.16 },
  400: { color: '#6E4BFF', lightRatio: 5.11, darkRatio: 4.11 },
  500: { color: '#4E24FF', lightRatio: 6.95, darkRatio: 3.02 },
  600: { color: '#421FD9', lightRatio: 8.64, darkRatio: 2.43 },
  700: { color: '#371AB5', lightRatio: 10.62, darkRatio: 1.98 },
  800: { color: '#2C1591', lightRatio: 12.94, darkRatio: 1.62 },
  900: { color: '#231073', lightRatio: 15.07, darkRatio: 1.39 }
})

export const purple = () => ({
  '050': { color: '#F5EBFF', lightRatio: 1.15, darkRatio: 18.21 },
  100: { color: '#E6CEFF', lightRatio: 1.43, darkRatio: 14.64 },
  200: { color: '#D2A7FF', lightRatio: 1.96, darkRatio: 10.71 },
  300: { color: '#BD7EFF', lightRatio: 2.77, darkRatio: 7.59 },
  400: { color: '#A958FF', lightRatio: 3.80, darkRatio: 5.53 },
  500: { color: '#9633FF', lightRatio: 4.98, darkRatio: 4.21 },
  600: { color: '#802BD9', lightRatio: 6.43, darkRatio: 3.27 },
  700: { color: '#6B24B5', lightRatio: 8.25, darkRatio: 2.54 },
  800: { color: '#561D91', lightRatio: 10.60, darkRatio: 1.98 },
  900: { color: '#441773', lightRatio: 13.00, darkRatio: 1.62 }
})

export const pink = () => ({
  '050': { color: '#FBEAF7', lightRatio: 1.15, darkRatio: 18.21 },
  100: { color: '#F4CDEB', lightRatio: 1.42, darkRatio: 14.78 },
  200: { color: '#ECA5DA', lightRatio: 1.92, darkRatio: 10.96 },
  300: { color: '#E37BC9', lightRatio: 2.64, darkRatio: 7.94 },
  400: { color: '#DA54B9', lightRatio: 3.53, darkRatio: 5.95 },
  500: { color: '#D22EEA', lightRatio: 4.46, darkRatio: 4.71 },
  600: { color: '#B32791', lightRatio: 5.81, darkRatio: 3.62 },
  700: { color: '#952179', lightRatio: 7.58, darkRatio: 2.77 },
  800: { color: '#781A61', lightRatio: 9.91, darkRatio: 2.12 },
  900: { color: '#5E154C', lightRatio: 12.44, darkRatio: 1.69 }
})

export const red = () => ({
  '050': { color: '#FFDEE7', lightRatio: 1.13, darkRatio: 18.52 },
  100: { color: '#FFD3C5', lightRatio: 1.37, darkRatio: 15.38 },
  200: { color: '#FFB098', lightRatio: 1.76, darkRatio: 11.92 },
  300: { color: '#FF8C68', lightRatio: 2.28, darkRatio: 9.20 },
  400: { color: '#FF693A', lightRatio: 2.86, darkRatio: 7.33 },
  500: { color: '#FF480F', lightRatio: 3.39, darkRatio: 6.19 },
  600: { color: '#D93D0D', lightRatio: 4.54, darkRatio: 4.62 },
  700: { color: '#B5330B', lightRatio: 6.10, darkRatio: 3.44 },
  800: { color: '#912909', lightRatio: 8.32, darkRatio: 2.53 },
  900: { color: '#732007', lightRatio: 10.83, darkRatio: 1.94 }
})

export const orange = () => ({
  '050': { color: '#FEF6E8', lightRatio: 1.07, darkRatio: 19.56 },
  100: { color: '#FCE8C8', lightRatio: 1.20, darkRatio: 17.52 },
  200: { color: '#FAD69D', lightRatio: 1.38, darkRatio: 15.17 },
  300: { color: '#F8C36F', lightRatio: 1.61, darkRatio: 13.03 },
  400: { color: '#F6B143', lightRatio: 1.86, darkRatio: 11.29 },
  500: { color: '#F4A01A', lightRatio: 2.12, darkRatio: 9.89 },
  600: { color: '#CF8816', lightRatio: 2.92, darkRatio: 7.71 },
  700: { color: '#AD7212', lightRatio: 4.04, darkRatio: 5.19 },
  800: { color: '#8B5B0F', lightRatio: 5.83, darkRatio: 3.60 },
  900: { color: '#6E480C', lightRatio: 8.09, darkRatio: 2.60 }
})

export const yellow = () => ({
  '050': { color: '#fdfee9', lightRatio: 1.02, darkRatio: 20.53 },
  100: { color: '#fafdca', lightRatio: 1.05, darkRatio: 19.97 },
  200: { color: '#F6FCA1', lightRatio: 1.08, darkRatio: 19.36 },
  300: { color: '#F2FB75', lightRatio: 1.12, darkRatio: 18.83 },
  400: { color: '#EEF94B', lightRatio: 1.15, darkRatio: 18.29 },
  500: { color: '#EAF824', lightRatio: 1.17, darkRatio: 17.95 },
  600: { color: '#C7D31F', lightRatio: 1.65, darkRatio: 12.77 },
  700: { color: '#A6B01A', lightRatio: 2.37, darkRatio: 8.85 },
  800: { color: '#858D15', lightRatio: 3.61, darkRatio: 5.82 },
  900: { color: '#697010', lightRatio: 5.35, darkRatio: 3.93 }
})

export const lime = () => ({
  '050': { color: '#F4FBE8', lightRatio: 1.06, darkRatio: 19.81 },
  100: { color: '#E4F5C7', lightRatio: 1.15, darkRatio: 18.18 },
  200: { color: '#CFED9B', lightRatio: 1.29, darkRatio: 16.24 },
  300: { color: '#B8E56C', lightRatio: 1.45, darkRatio: 14.46 },
  400: { color: '#A3DD40', lightRatio: 1.62, darkRatio: 12.97 },
  500: { color: '#8FD516', lightRatio: 1.80, darkRatio: 11.70 },
  600: { color: '#7AB513', lightRatio: 2.49, darkRatio: 8.45 },
  700: { color: '#669710', lightRatio: 3.50, darkRatio: 6.00 },
  800: { color: '#52790D', lightRatio: 5.12, darkRatio: 4.10 },
  900: { color: '#40600A', lightRatio: 7.25, darkRatio: 2.90 }
})

export const green = () => ({
  '050': { color: '#EBF7E6', lightRatio: 1.11, darkRatio: 18.98 },
  100: { color: '#CEEDC4', lightRatio: 1.27, darkRatio: 16.54 },
  200: { color: '#A8DE95', lightRatio: 1.55, darkRatio: 13.55 },
  300: { color: '#7FCE63', lightRatio: 1.92, darkRatio: 10.91 },
  400: { color: '#59C034', lightRatio: 2.33, darkRatio: 9.01 },
  500: { color: '#34B208', lightRatio: 2.79, darkRatio: 7.52 },
  600: { color: '#2C9707', lightRatio: 3.79, darkRatio: 5.54 },
  700: { color: '#257E06', lightRatio: 5.17, darkRatio: 4.07 },
  800: { color: '#1E6505', lightRatio: 7.19, darkRatio: 2.92 },
  900: { color: '#175004', lightRatio: 9.61, darkRatio: 2.19 }
})

export const cyan = () => ({
  '050': { color: '#E6FDFB', lightRatio: 1.06, darkRatio: 19.81 },
  100: { color: '#C2FBF5', lightRatio: 1.14, darkRatio: 18.41 },
  200: { color: '#91F7ED', lightRatio: 1.26, darkRatio: 16.73 },
  300: { color: '#5EF4E5', lightRatio: 1.35, darkRatio: 15.55 },
  400: { color: '#2EF0DD', lightRatio: 1.44, darkRatio: 14.62 },
  500: { color: '#00EDD6', lightRatio: 1.49, darkRatio: 14.08 },
  600: { color: '#00C9B6', lightRatio: 2.09, darkRatio: 10.03 },
  700: { color: '#00A898', lightRatio: 2.98, darkRatio: 7.05 },
  800: { color: '#00877A', lightRatio: 4.42, darkRatio: 4.75 },
  900: { color: '#006B60', lightRatio: 6.42, darkRatio: 3.27 }
})

// primary, secondary, and accent are set by the application based on firm choice
const allPalettes = new Map([
  ['primary', gray()],
  ['secondary', gray()],
  ['accent', gray()],
  ['gray', gray()],
  ['blue', blue()],
  ['indigo', indigo()],
  ['purple', purple()],
  ['pink', pink()],
  ['red', red()],
  ['orange', orange()],
  ['yellow', yellow()],
  ['lime', lime()],
  ['green', green()],
  ['cyan', cyan()]
])

export function resetDefaultPalettes () {
  allPalettes.set('gray', gray())
  allPalettes.set('blue', blue())
  allPalettes.set('indigo', indigo())
  allPalettes.set('purple', purple())
  allPalettes.set('pink', pink())
  allPalettes.set('red', red())
  allPalettes.set('orange', orange())
  allPalettes.set('yellow', yellow())
  allPalettes.set('lime', lime())
  allPalettes.set('green', green())
  allPalettes.set('cyan', cyan())
}

export function setPalette (key, palette) {
  const base = gray()
  const normalized = {
    ...base,
    ...(palette || {})
  }

  const withContrast = Object.entries(normalized).reduce((result, [key, value]) => {
    result[key] = {
      ...value,
      ...getContrast(value.color)
    }
    return result
  }, {})

  allPalettes.set(key, withContrast)
}

/**
 * Creates a rotated array of hex colors from the given palettes,
 * starting at 500 then alternating up/down through shades,
 * then filters by contrast ratio bounds.
 *
 * @param {Array<'gray'|'blue'|'indigo'|'purple'|'fuchsia'|'red'|'orange'|'yellow'|'lime'|'green'|'cyan'>} colorSets
 * @param {number} ratioLow – lower contrast ratio bound (default 2.0)
 * @param {number} ratioHigh – upper contrast ratio bound (default 16.0)
 * @param {'light'|'dark'} mode – which ratio to use (lightRatio or darkRatio)
 * @returns {string[]} array of hex color strings
 */
export function createChartTheme (
  colorSets,
  ratioLow = 2.0,
  ratioHigh = 16,
  mode = 'light'
) {
  const shadeKeys = ['050', '100', '200', '300', '400', '500', '600', '700', '800', '900']
  // start at index 5 ('500'), then +1, -1, +2, -2, …
  const order = [5, 6, 4, 7, 3, 8, 2, 9, 1, 0]
  const shadeOrder = order.map(i => shadeKeys[i])
  const ratioKey = mode === 'light' ? 'lightRatio' : 'darkRatio'
  const picks = []

  for (const shade of shadeOrder) {
    for (const name of colorSets) {
      const palette = allPalettes.get(name)
      if (!palette) {
        console.error('createChartTheme: Unknown palette', name)
        continue
      }
      const entry = palette[shade]
      if (!entry) continue
      picks.push({ color: entry.color, ratio: entry[ratioKey] })
    }
  }

  return picks
    .filter(({ ratio }) => ratio >= ratioLow && ratio <= ratioHigh)
    .map(({ color }) => color)
}

/**
 * Appends a hex transparency value to each hex color in the array
 * @param {string[]} colors – array of hex colors (e.g. "#rrggbb" or "#rgb")
 * @param {number} alpha – transparency as decimal between 0 and 1
 * @returns {string[]} new array of 8-digit hex colors (e.g. "#rrggbbaa")
 */
export function appendTransparency (colors, alpha) {
  if (!Array.isArray(colors)) {
    throw new Error('colors must be an array of hex color strings')
  }
  if (alpha < 0 || alpha > 1) {
    throw new Error('alpha must be between 0 and 1')
  }
  const aHex = Math.round(alpha * 255)
    .toString(16)
    .padStart(2, '0')
    .toLowerCase()
  return colors.map(col => {
    if (!col.startsWith('#')) {
      throw new Error(`invalid hex color "${col}"`)
    }
    let hex = col.slice(1)
    // expand shorthand "#rgb" → "rrggbb"
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map(c => c + c)
        .join('')
    }
    if (hex.length !== 6) {
      throw new Error(`invalid hex color "${col}"`)
    }
    return `#${hex}${aHex}`
  })
}
